import { render, staticRenderFns } from "./Logo.vue?vue&type=template&id=3b2f491c&scoped=true&"
import script from "./Logo.vue?vue&type=script&setup=true&lang=js&"
export * from "./Logo.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b2f491c",
  null
  
)

export default component.exports